import { render, staticRenderFns } from "./StepperTemaClaro.vue?vue&type=template&id=6f1c945c&scoped=true"
import script from "./StepperTemaClaro.vue?vue&type=script&lang=js"
export * from "./StepperTemaClaro.vue?vue&type=script&lang=js"
import style0 from "./StepperTemaClaro.vue?vue&type=style&index=0&id=6f1c945c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c945c",
  null
  
)

export default component.exports